import { StatementSummary } from '../../../domain/invoicing/statement'

export type StatementActionAffordances = {
  isPaid: boolean
  canSend: boolean
  canPay: boolean
  canDelete: boolean
  canMarkNotPaid: boolean
  sendIsReminder: boolean
  sendLabel: string
}

export const statementActionAffordances = (
  statement: Pick<StatementSummary, 'balance' | 'wasEmailSent' | 'hasManualPayment'>
): StatementActionAffordances => {
  const isPaid = statement.balance === 0
  const sendIsReminder = statement.wasEmailSent
  return {
    isPaid,
    canSend: !isPaid,
    canPay: !isPaid,
    canDelete: !isPaid,
    canMarkNotPaid: isPaid && statement.hasManualPayment,
    sendIsReminder,
    sendLabel: sendIsReminder ? 'Send Reminder to Customer' : 'Send Statement',
  }
}

export const canViewStatementReceipt = (
  statement: Pick<StatementSummary, 'balance'>,
  paymentPageUrl: string | undefined
): boolean => statement.balance === 0 && (paymentPageUrl?.length ?? 0) > 0

export const markNotPaidConfirmation = (
  statement: Pick<StatementSummary, 'statementNumber' | 'invoiceCount'>
) => ({
  title: `Mark statement ${statement.statementNumber} not paid?`,
  description: `This removes the manual payment from the statement and its ${statement.invoiceCount} invoices.`,
})
